import { mk_widget, Action, IOWidget } from '../widget'
import * as React from 'react'

export interface LifecycleMethods<s> {
  componentDidMount?: (update: (_: Action<s>) => void) => void
  componentWillUnmount?: (update: (_: Action<s>) => void) => void
  componentDidUpdate?: (update: (_: Action<s>) => void) => void
  shouldComponentUpdate?: (prev:s, next:s) => boolean,
}

export interface LifecycleProps<s> extends LifecycleMethods<s> {
  input: s
  widget_s: IOWidget<s, Action<s>>
  on_done_s: (output_s: Action<s>) => void
}
export class Lifecycle<s> extends React.Component<
  LifecycleProps<s>,
  {}
> {
  constructor(props: LifecycleProps<s>, context: any) {
    super(props, context)
  }

  componentDidMount() {
    !!this.props.componentDidMount && 
      this.props.componentDidMount(this.props.on_done_s)
  }

  componentWillUnmount() {
    !!this.props.componentWillUnmount && 
      this.props.componentWillUnmount(this.props.on_done_s)
  }

  componentDidUpdate() {
    !!this.props.componentDidUpdate &&
      this.props.componentDidUpdate(this.props.on_done_s)
  }

  shouldComponentUpdate(nextProps: LifecycleProps<s>) {
    return !this.props.shouldComponentUpdate || this.props.shouldComponentUpdate(this.props.input, nextProps.input)
  }

  render() {
    return this.props
      .widget_s(this.props.input)
      .run(new_s => this.props.on_done_s(new_s))
  }
}
export let lifecycle = function<s>(
  metods: LifecycleMethods<s>
): (widget_s: IOWidget<s, Action<s>>) => IOWidget<s, Action<s>> {
  return widget_s => (input: s) =>
    mk_widget({
      run: (on_done_s: (output: Action<s>) => void) =>
        React.createElement<LifecycleProps<s>>(Lifecycle, {
          ...metods,
          on_done_s,
          widget_s,
          input
        })
      })
  }